<dx-popup #popupHandbuch *ngIf="true" [showTitle]="true" title="Handbücher" [height]="700" [width]="1000" [dragEnabled]="false" [hideOnOutsideClick]="false" (onHidden)="onHiddenPopupHandbuch($event)">
  <div *dxTemplate="let data of 'content'">
    <div class="handbuch-popup-wait" *ngIf="!init">
      <span class="handbuch-popup-wait-text">Lade Daten...</span>
    </div>

    <div class="handbuch-popup-content" *ngIf="init">
      <div class="handbuch-popup-searchView">
        <dx-text-box [(value)]="searchText" [showClearButton]="true" placeholder="Suche..." valueChangeEvent="keyup" (onValueChanged)="valueChanged($event)"></dx-text-box>
      </div>

      <dx-scroll-view class="handbuch-popup-scrollView" #scrollView [scrollByContent]="true" [scrollByThumb]="true" [bounceEnabled]="false" width="100%" height="100%">
        <div class="handbuch-popup-item" *ngFor="let data of filteredDatas; let i = index">
          <div class="handbuch-popup-item-name" (click)="onCollapseClick($event, data)">
            <div class="handbuch-popup-item-name-text" [innerHTML]="data.name"></div>

            <div class="handbuch-popup-item-name-btn-container">
              <dx-button class="handbuch-popup-item-name-btn" type="default" icon="search" (click)="onShowClick($event, data)"> </dx-button>
              <dx-button class="handbuch-popup-item-name-btn" type="default" icon="download" (click)="onDownloadClick($event, data)"> </dx-button>

              <dx-button class="handbuch-popup-item-name-btn" type="default" icon="chevronup" *ngIf="data.isOpen"> </dx-button>

              <dx-button class="handbuch-popup-item-name-btn" type="default" icon="chevrondown" *ngIf="!data.isOpen"> </dx-button>
            </div>
          </div>

          <div class="handbuch-popup-item-beschreibung" *ngIf="data.isOpen" [innerHTML]="data.beschreibung"></div>
        </div>
      </dx-scroll-view>
    </div>
  </div>

  <dxi-popup-toolbar-item
    widget="dxButton"
    location="after"
    toolbar="bottom"
    [options]="{
      text: 'Schließen',
      onClick: onClickClose
    }">
  </dxi-popup-toolbar-item>
</dx-popup>

<dx-popup #popupShow class="popup" *ngIf="true" [showTitle]="true" title="Hilfe" [height]="'90%'" [width]="'80%'" [dragEnabled]="false" [hideOnOutsideClick]="false" (onHidden)="onHiddenPopupShow($event)" [(visible)]="popupVisible">
  <div *dxTemplate="let data of 'content'">
    <cz-document-viewer *ngIf="popupVisible" [pdfUrl]="pdfSrc"></cz-document-viewer>
  </div>

  <dxi-popup-toolbar-item
    widget="dxButton"
    location="after"
    toolbar="bottom"
    [options]="{
      text: 'Download',
      onClick: downloadPopupShow
    }">
  </dxi-popup-toolbar-item>

  <dxi-popup-toolbar-item
    widget="dxButton"
    location="after"
    toolbar="bottom"
    [options]="{
      text: 'Schließen',
      onClick: hidePopupShow
    }">
  </dxi-popup-toolbar-item>
</dx-popup>
